import React from 'react';

import { CommonPropTypes } from '../Icons.types';

const Chevron: React.FC<CommonPropTypes> = ({ className }) => {
  return (
    <svg
      className={className}
      width='70'
      height='70'
      viewBox='0 0 70 70'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M42.8108 32.7279L34.1921 24.185C33.6411 23.6402 32.8976 23.3346 32.1227 23.3346C31.3479 23.3346 30.6043 23.6402 30.0533 24.185C29.7816 24.4526 29.5659 24.7716 29.4186 25.1233C29.2713 25.4751 29.1955 25.8526 29.1955 26.234C29.1955 26.6153 29.2713 26.9929 29.4186 27.3446C29.5659 27.6964 29.7816 28.0153 30.0533 28.2829L36.8113 34.9854L30.0242 41.7142C29.7526 41.9825 29.5371 42.302 29.3899 42.6542C29.2428 43.0064 29.1671 43.3843 29.1671 43.766C29.1671 44.1478 29.2428 44.5257 29.3899 44.8779C29.5371 45.2301 29.7526 45.5496 30.0242 45.8179C30.5755 46.3621 31.3189 46.6672 32.0935 46.6672C32.8682 46.6672 33.6116 46.3621 34.1629 45.8179L42.8108 37.2429C43.4108 36.6399 43.7484 35.8244 43.75 34.9738C43.75 34.16 43.4379 33.3492 42.8108 32.7279Z'
        fill='#343435'
      />
    </svg>
  );
};

export default Chevron;
